import filesService from "@/services/files-service";

export function invokeGetFileFromServer(file) {
  if (file.id) {
    return filesService.getStoredFile(file.id);
  }
  return filesService.getTmpStoredFile(file.data.pathName);
}